import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { CircularProgress, Dialog } from '@mui/material'
import { useEffect, useState } from 'react'
import { mediaURL } from 'src/consumer/services'
import { DisplayFlexColumn } from 'src/shared/styled/sharedPrimitives'
import { DisplayFlex } from '../ConsumerProfilePage/ProfileLeftPannelStyle'
import {
  MentalStateTypeBackButtonContainer,
  MentalStateTypeButton,
  MentalStateTypeModalMUIPaper,
  MentalStateTypeQuestion,
  MoodCardAnswer,
  MoodCardOptionImage,
  MoodCardQuestion,
} from './MentalStateStyles'
import { postMentalState } from './mentalStateService'

export const MentalStateTypeComponentDialog = ({
  open,
  onClose,
  mentalStateDialogData,
  src,
  srcId,
  afterSubmitFunction = () => {},
}) => {
  const mentalStateTypeComponentData = {
    ...mentalStateDialogData,
    itemId: mentalStateDialogData?.id,
    question: mentalStateDialogData?.question,
    title: mentalStateDialogData?.title,
    qaTexts: mentalStateDialogData?.dailyPlayAltText,
    options: mentalStateDialogData?.options,
    completedValue: mentalStateDialogData?.completedValue,
    type: mentalStateDialogData?.type,
  }

  return (
    <Dialog PaperComponent={MentalStateTypeModalMUIPaper} open={open} onClose={onClose}>
      <MentalStateTypeComponent
        mentalStateTypeComponentData={mentalStateTypeComponentData}
        onClose={onClose}
        src={src}
        srcId={srcId}
        afterSubmitFunction={afterSubmitFunction}
      />
    </Dialog>
  )
}

export const MentalStateTypeComponent = ({
  mentalStateTypeComponentData,
  timeSlot = 'fullday',
  src = 'default',
  srcId = 'default',
  onClose,
  afterSubmitFunction = () => {},
}) => {
  const [choiceMadeBool, setChoiceMadeBool] = useState(false)
  const [chosenOption, setChosenOption] = useState()
  const [saving, setSaving] = useState(false)

  let question, answer

  if (mentalStateTypeComponentData?.qaTexts?.[timeSlot]) {
    question =
      mentalStateTypeComponentData?.qaTexts?.[timeSlot]?.question ||
      mentalStateTypeComponentData?.question
    answer =
      mentalStateTypeComponentData?.qaTexts?.[timeSlot]?.answer ||
      mentalStateTypeComponentData?.answer
  }

  const handleOptionClick = async (item) => {
    setChoiceMadeBool(true)
    setChosenOption(item)
  }

  async function submitMentalStateType() {
    await postMentalState(chosenOption?.type, chosenOption?.id, src, srcId)
  }

  async function handleSubmit() {
    setSaving(true)
    await submitMentalStateType()
    await afterSubmitFunction()
    onClose()
    setSaving(false)
  }

  useEffect(() => {
    if (mentalStateTypeComponentData?.completedValue) {
      const dataOfLastSelectedOption = mentalStateTypeComponentData?.options?.find(
        (item) => item?.id === mentalStateTypeComponentData?.completedValue,
      )
      setChosenOption(dataOfLastSelectedOption)
      setChoiceMadeBool(true)
    }
  }, [])

  return (
    <>
      {!choiceMadeBool && (
        <DisplayFlexColumn
          style={{ gap: '30px', justifyContent: 'center', height: '100%', padding: '20px 0px' }}
        >
          <MentalStateTypeQuestion>{question}</MentalStateTypeQuestion>
          <DisplayFlex style={{ justifyContent: 'space-around', height: '100%' }}>
            {mentalStateTypeComponentData?.options
              ?.sort((m1, m2) => m1.orderId - m2.orderId)
              ?.map((item, index) => {
                return (
                  <MoodCardOptionImage
                    key={index}
                    src={`${mediaURL}${item?.iconId || item?.icon}`}
                    onClick={() => {
                      handleOptionClick(item, mentalStateTypeComponentData)
                    }}
                  />
                )
              })}
          </DisplayFlex>
        </DisplayFlexColumn>
      )}
      {choiceMadeBool && (
        <>
          <div style={{ width: '100%' }}>
            {!saving && (
              <MentalStateTypeBackButtonContainer
                onClick={() => {
                  setChoiceMadeBool(false)
                  setChosenOption()
                }}
              >
                <ArrowBackIcon sx={{ color: '#fff' }} />
              </MentalStateTypeBackButtonContainer>
            )}
          </div>
          <MoodCardAnswer>
            <MoodCardQuestion style={{ textAlign: 'left', width: '100%' }}>
              {answer?.replace('{1}', chosenOption?.name)}
            </MoodCardQuestion>
            <MoodCardOptionImage src={`${mediaURL}${chosenOption?.iconId || chosenOption?.icon}`} />
          </MoodCardAnswer>
          <MentalStateTypeButton onClick={handleSubmit}>
            {saving ? (
              <CircularProgress sx={{ width: '25px !important', height: '25px !important', color: '#595cfb !important' }} />
            ) : (
              'Submit'
            )}
          </MentalStateTypeButton>
        </>
      )}
    </>
  )
}
